import debounce from 'lodash/debounce';

import template from './card-view.vhtml';
import QdCard from '../card/card.js';

export default {
	template,
	props: {
		productLineId: {
			type: Number,
			default: null,
		},
		postType: {
			type: String,
			default: 'products',
		},
		productLineColor: {
			type: String,
			default: '#89c0bd',
		},
		perPage: {
			type: Number,
			default: -1,
		},
	},
	data() {
		return {
			cards: [],
			page: 1,
			isLoading: false,
			isFetching: false,
			loadMore: false,
			loadedOnce: false,
		};
	},
	computed: {
		hasLoaded() {
			return this.loadedOnce && this.cards.length === 0;
		},
		buttonContentColor() {
			if(this.productLineColor === '#ffffff') {
				return '#656565';
			} else {
				return '#ffffff';
			}
		}
	},
	watch: {
		filters: function() {
			this.reload();
		},
	},
	methods: {
		fetchMore() {
			this.page++;
			this.isFetching = true;
			getItems( this.postType, this.productLineId, this.perPage, this.page )
				.then(items => {
					if ( items ) {
						this.loadMore = this.perPage * this.page < items.total;
						this.cards = this.cards.concat(items.products);
					}
				})
				.always(() => this.isFetching = false);
		},
		reload: debounce( function() {
			this.isLoading = true;
			getItems( this.postType, this.productLineId, this.perPage, this.page )
                .then( items => {
					if ( items ) {
						this.loadMore = this.perPage * this.page < items.total;
						this.cards = items.products;
					}
				})
                .always( () => {
					this.isLoading = false;
					this.loadedOnce = true;  
				});
			}, 500 ),
	},
	created() {
		this.reload();
	},
	components: {
		QdCard,
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems(postType = 'products' , productLineId = null, perPage,  page ) {
	const params = {
		'post_type' : postType,
		'product_line_id': productLineId,
		'posts_per_page': perPage,
		'page': page,
		'lang': window.siteData.language,
	};

	return $.get( `/wp-json/kristensen/v1/products`, params );
}



// WEBPACK FOOTER //
// ./assets/_js/components/card-view/card-view.js